export default __webpack_public_path__ + "static/media/teamwork-high-five-1.97c9cc02.png";